require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");

import 'swiper/css/bundle';

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/bootstrap-tab");
require("./vendor/li-marquee");

require("./custom/header.es6");
require("./custom/anchor.es6");

(function ($) {

    if ($(".section-scrollTrigger").length > 0) {
        require("./custom/general-scroll-trigger.es6");
    }

    if ($(".section-block-bar").length > 0) {
        require("./page_builder/section_block_bar.es6");
    }

    if ($(".section-card-roll").length > 0) {
        require("./page_builder/section_card_roll.es6");
    }

    if ($(".phone-container").length > 0) {
        require("./page_builder/section_discover_stadami.es6");
    }

    if ($(".section-reviews").length > 0) {
        require("./page_builder/section_reviews.es6");
    }

    if ($(".section-faq").length > 0) {
        require("./page_builder/section_faq.es6");
    }

    if ($(".section-blog-list").length > 0) {
        require("./custom/archive-blog.es6");
    }

    if ($(".section-hero-single-blog").length > 0) {
        require("./custom/single-blog.es6");
    }

    if ($(".custom-drag-sticker").length > 0) {
        require("./custom/custom-drag-sticker.es6");
    }

    if ($(".page-404").length > 0) {
        require("./custom/404.es6");
    }

    if ($(".section-calculator").length > 0) {
        require("./page_builder/section_calculator.es6");
    }

    if ($(".section-welcome-to-stadami").length > 0) {
        require("./page_builder/section_welcome_to_stadami.es6");
    }

    if ($(".section-join-stadami").length > 0) {
        require("./page_builder/section_join_stadami.es6");
    }

    if ($(".page-template-page-claim-your-business").length > 0) {
        require("./page_builder/section_claim_business.es6");
    }

})(jQuery);